<template>
  <VDialogV3
    id="mass-change-dialog"
    position="center"
    width="300px"
    :loading="false"
    :title="headerText"
    @submit="onSubmit"
    close-on-overlay-click
  >
    <div>
      <VDateRangeInputNew
        v-if="fieldName === 'preorderShipmentPeriod'"
        v-model="value"
        placeholder="Введите период"
        :validate-method="validateDate"
      />

      <VDateInput
        v-if="fieldName === 'desiredReceiptDate'"
        v-model="value"
        placeholder="Введите дату"
        :validate-method="validateDate"
      />

      <VSelect
        v-if="fieldName === 'buyerProductionSite'"
        v-model="value"
        placeholder="Выберите площадку"
        :options="productionSiteOptions"
      />

      <VSelect
        v-if="fieldName === 'responsibleBuyer'"
        v-model="value"
        placeholder="Выберите ответственного"
        :search-function="pattern => PersonsService.searchPersons(pattern, $core.currentPartner.id)"
      />
    </div>
  </VDialogV3>
</template>

<script lang="ts">

import DateRange      from '@/core/types/DateRange';
import DateSimple     from '@/core/types/DateSimple';
import PersonsService from '@/domains/Persons/PersonsService';

const HEADERS: Record<string, string> = {
  desiredReceiptDate:     'Дата поставки',
  preorderShipmentPeriod: 'Период поставки',
  buyerProductionSite:    'Площадка',
  responsibleBuyer:       'Ответственный',
};

export default defineComponent({
  name: 'MassChangeDialog',

  props: {
    fieldName: {
      type:     String,
      required: true,
    },

    productionSiteOptions: {
      type:    Array,
      default: () => [],
    },

    /** Object: период { start, end }, площадка, ответственный; Date: дата поставки */
    presetValue: {
      type:    [Object, Date] as PropType<any>,
      default: null,
    },
  },

  emits: ['close', 'save'],

  setup() {
    return {
      PersonsService,
    };
  },

  data() {
    return {
      value: null as any,
    };
  },

  computed: {
    headerText(): string {
      return HEADERS[this.fieldName] ?? 'Массовое изменение';
    },
  },

  created() {
    this.applyPresetValue();
  },

  methods: {
    /** Инициализирует значение из пресета (для периода — собирает DateRange) */
    applyPresetValue(): void {
      if (this.fieldName === 'preorderShipmentPeriod') {
        if (this.presetValue) {
          this.value = DateRange.fromObject(this.presetValue);
        }
        else {
          this.value = new DateRange();
        }
      }
      else {
        this.value = this.presetValue ?? null;
      }
    },

    /** Отдаёт изменённое поле родителю и закрывает диалог */
    onSubmit(): void {
      this.$emit('save', { [this.fieldName]: this.value });
      this.$core.dialogs.MassChangeDialog.hide();
    },

    /** Запрещает прошедшую дату */
    validateDate(date: any): string | null {
      if (this.$core.utils.date.isDate(date) === false) return null;

      const today      = DateSimple.today();
      const dateSimple = new DateSimple(date);

      if (dateSimple.isBefore(today) || dateSimple.equals(today)) {
        return 'Нельзя указать прошедшую дату';
      }

      return null;
    },
  },
});
</script>
